

import HeroBanner from "../../components/HeroBanner";
import Steps from "../../components/Steps";
import {usePrismicDocumentsByTag} from '@prismicio/react';

export default function IndiaProgram()  {

    const [india] = usePrismicDocumentsByTag("india");

    return (
        <main>
            {india && (
                <div className="program-container">
                    <HeroBanner
                        id="india-program"
                        heading={india.results[0].data.hero_title[0].text}>
                    </HeroBanner>
                    <Steps
                        image={india.results[0].data['list-image'].url}
                        paragraph={india.results[0].data.paragraph[0].text}
                        heading={india.results[0].data.heading[0].text}
                        steps={india.results[0].data.step_list}
                    />

                    <section>
                        <div className="container">
                            <div className="section-title">
                                <h2>{india.results[0].data.families_number[0].text}</h2>
                            </div>
                        </div>
                    </section>
                </div>
            )}
        </main>
    )

}